import {allHasValues, hasValue} from "@raskrask-dk/raskrask-utils";
import type {State, StateName} from "../states/state";

export abstract class Action<Type extends string, GData> {
  public abstract type: Type; // For type completion during switch cases
  protected _data?: GData;
  protected state: State<any, StateName>;

  constructor(state: State<any, StateName>, data?: GData) {
    this.state = state;
    this._data = data;
  }

  /**
   * Tells if an action is callable.
   * Don't confuse this with future.
   * OBS! SHould this exist? when is isValid false but isDoable true?
   * @returns {boolean} true if action can be called
   */
  abstract isDoable(): boolean;

  /**
   * If a method is valid (implicitly validated).
   * @returns {boolean} true if action and data is valid
   */
  abstract isValid(): boolean;

  /**
   * TODO: should return a copy and not reference
   */
  public get data(): GData {
    return this._data as GData;
  }

  /**
   * @param array of values to check if null, undefined or nan
   * @returns true if no values are null, undefined or nan
   */
  protected allHasValues(...args: unknown[]): boolean {
    return allHasValues(...args);
  }

  /**
   * @param value to check if null, undefined or nan
   * @returns true if value are null, undefined or nan
   */
  protected hasValue<T>(value: T | undefined | null): value is T {
    return hasValue(value);
  }
}
